import { render, staticRenderFns } from "./goodsReserveView.vue?vue&type=template&id=3ba968c6&"
import script from "./goodsReserveView.vue?vue&type=script&lang=js&"
export * from "./goodsReserveView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports